import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import SectionContainer from './components/section/SectionContainer'
import { TextButton } from '~/core/ui/TextButton'
import Link from 'next/link'
import Image from 'next/image'
import { cn } from '~/core/ui/utils'
import { TALENT_INTELLIGENCE_URL } from '~/core/constants/url'

const PLUS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none">
    <line y1="6.5" x2="13" y2="6.5" stroke="#9CA3AF" />
    <line x1="6.5" y1="2.18557e-08" x2="6.5" y2="13" stroke="#9CA3AF" />
  </svg>
)

const ICON_1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none">
    <path
      d="M15.5 20.25L1.57999 12.0834V20.25L15.5 28.4167V20.25Z"
      fill="#D4DAE0"
    />
    <path
      d="M29.42 17.3334L16.08 24.9167L15.5 27.8334L29.42 20.25V17.3334Z"
      fill="#D4DAE0"
    />
    <path
      d="M20.72 23.1666C17.936 23.1666 16.8533 20.8333 16.66 19.6666L16.08 20.25V25.5L20.72 23.1666Z"
      fill="#D4DAE0"
    />
    <path
      d="M7.00977 8.32507C7.12015 8.29597 7.22548 8.29819 7.32324 8.32996C7.45317 8.37217 7.56429 8.46496 7.65332 8.59656H7.65234C7.8391 8.86296 7.75681 9.20325 7.5 9.40417L7.50098 9.40515C7.39847 9.48926 7.27569 9.54508 7.16406 9.60535L7.16504 9.60632C5.79472 10.392 4.42403 11.1771 3.05371 11.9628L3.05273 11.9637C2.97431 12.0067 2.90262 12.0551 2.80957 12.1161C2.84115 12.1367 2.87045 12.1559 2.89746 12.1737L3.02441 12.2499L3.02734 12.2509L3.00195 12.2948L3.02734 12.2518C7.10214 14.6086 11.1859 16.974 15.2607 19.3397H15.2617C15.3496 19.3882 15.4181 19.4179 15.4854 19.4247C15.5504 19.4311 15.62 19.4167 15.7109 19.3671L28.1602 12.2958L28.1621 12.2948L28.2646 12.2352C28.2828 12.2234 28.3017 12.2097 28.3232 12.1952L26.2285 10.9901C25.3575 10.4907 24.4666 9.99815 23.6113 9.46179V9.46277C23.521 9.40741 23.4399 9.30742 23.3818 9.1991C23.3237 9.09057 23.2852 8.96615 23.2852 8.8573C23.2852 8.76326 23.3441 8.66001 23.415 8.57507C23.4874 8.48843 23.5816 8.40989 23.6689 8.36609L23.7295 8.34363C23.7937 8.32677 23.8678 8.32511 23.9385 8.33386C24.0333 8.3456 24.1304 8.3769 24.2041 8.42078H24.2051C25.5866 9.20426 26.9631 9.98815 28.3311 10.7831L29.6963 11.5819L29.6973 11.5829L29.7627 11.6317C29.8271 11.6888 29.8855 11.7666 29.9307 11.8485C29.9908 11.9576 30.0322 12.0822 30.0322 12.1874L30.0449 16.2587C30.046 17.6159 30.0454 18.9731 30.0498 20.33L30.0391 20.4667C30.0178 20.5945 29.9659 20.6966 29.8926 20.7831C29.7965 20.8962 29.6653 20.981 29.5273 21.0614H29.5264C28.2585 21.7934 26.993 22.5255 25.7285 23.2587L21.9365 25.4628C19.9788 26.5968 18.0121 27.7311 16.0635 28.8739L16.0625 28.8729C15.871 28.9871 15.6941 29.0476 15.5127 29.0477C15.3764 29.0477 15.2406 29.0142 15.0986 28.9491L14.9541 28.8739C12.7117 27.5658 10.4693 26.262 8.22461 24.9618L1.48242 21.0702C1.2999 20.9649 1.16524 20.848 1.07715 20.701C0.988937 20.5539 0.95021 20.3813 0.950195 20.1698L0.958984 18.2128C0.963572 16.2552 0.956869 14.295 0.950195 12.3397L0.957031 12.1971C0.970483 12.0606 1.00457 11.9409 1.06543 11.8348C1.14676 11.6932 1.27268 11.5801 1.44727 11.4833L6.61621 8.51941L6.75195 8.43933C6.79833 8.41324 6.84623 8.38804 6.89648 8.36511H6.89746L7.00977 8.32507ZM2.17969 13.2118C2.17377 13.2367 2.17095 13.2481 2.1709 13.2587V19.8661C2.1709 19.9707 2.20066 20.0315 2.24316 20.077C2.28923 20.1262 2.35253 20.1602 2.43164 20.2069H2.43066C4.46841 21.3855 6.50886 22.5661 8.54883 23.7469L14.666 27.287L14.667 27.288L14.8936 27.4012V20.911C14.8936 20.7687 14.8725 20.6643 14.8242 20.58C14.7879 20.5167 14.7342 20.4609 14.6572 20.4081L14.5723 20.3563C13.2465 19.5974 11.9247 18.8337 10.6045 18.0692L6.64355 15.7753C5.17046 14.9219 3.6972 14.0686 2.18164 13.1981C2.1806 13.2027 2.18066 13.2077 2.17969 13.2118ZM28.8281 13.3495H28.8271L28.8262 13.3505H28.8252L28.8242 13.3514H28.8232L28.8223 13.3524H28.8213L28.8203 13.3534H28.8193L28.8184 13.3544H28.8174L28.8164 13.3553H28.8154L28.8145 13.3563H28.8135L28.8125 13.3573H28.8115L28.8105 13.3583H28.8096L28.8086 13.3593H28.8076L28.8066 13.3602H28.8057V13.3612H28.8037L28.8027 13.3622H28.8018L28.8008 13.3632H28.7998L28.7988 13.3641H28.7979L28.7969 13.3651H28.7959L28.7949 13.3661H28.7939V13.3671H28.792L28.791 13.368H28.79L28.7891 13.369H28.7881V13.37H28.7861L28.7852 13.371H28.7842L28.7832 13.3719H28.7822L28.7812 13.3729H28.7803V13.3739H28.7783V13.3749H28.7764V13.3759H28.7744V13.3768H28.7725V13.3778H28.7705V13.3788H28.7686V13.3798H28.7666V13.3807H28.7646L28.7637 13.3817H28.7627L28.7617 13.3827H28.7607V13.3837H28.7588V13.3846H28.7568L28.7559 13.3856H28.7549V13.3866H28.7529V13.3876H28.751V13.3885H28.749V13.3895H28.7471V13.3905H28.7451V13.3915H28.7432V13.3925H28.7412L28.7402 13.3934H28.7393V13.3944H28.7373V13.3954H28.7354V13.3964H28.7334V13.3973H28.7314V13.3983H28.7295V13.3993H28.7275V13.4003H28.7256V13.4012H28.7236V13.4022H28.7217V13.4032H28.7197V13.4042H28.7178V13.4052H28.7158V13.4061H28.7139V13.4071H28.7119V13.4081H28.71V13.4091H28.708V13.41H28.7061V13.411H28.7041V13.412H28.7021V13.413H28.7002V13.4139H28.6982V13.4149H28.6963V13.4159H28.6943V13.4169H28.6924V13.4178H28.6904V13.4188H28.6885V13.4198H28.6875C24.5596 15.7586 20.4309 18.1055 16.2939 20.4354L16.2949 20.4364C16.2085 20.486 16.1634 20.5366 16.1387 20.5927C16.1131 20.6506 16.1065 20.7199 16.1064 20.8124V27.1698C16.1064 27.2412 16.1073 27.3108 16.1162 27.3983C16.1357 27.3897 16.1538 27.3819 16.1699 27.3749C16.203 27.3605 16.2284 27.349 16.251 27.3339L16.2539 27.3319L28.6406 20.1532L28.6973 20.1151C28.7473 20.0768 28.7772 20.0362 28.7959 19.993C28.8215 19.9338 28.8291 19.8647 28.8291 19.7772V13.3485L28.8281 13.3495ZM15.4951 0.964722C15.6484 0.96352 15.7993 1.01151 15.9561 1.10828H15.957C17.8967 2.24209 19.8452 3.36713 21.8027 4.49207L21.9102 4.5614C22.0092 4.63382 22.0857 4.71692 22.1406 4.81433C22.2138 4.94435 22.2461 5.09715 22.2461 5.27722V11.9911C22.2461 12.1748 22.2165 12.3311 22.1436 12.4657C22.0886 12.5669 22.0101 12.6533 21.9062 12.7294L21.7939 12.8026C19.8453 13.9276 17.8968 15.0526 15.9482 16.1864H15.9473C15.7861 16.2788 15.6349 16.3246 15.4824 16.3221C15.3683 16.3203 15.2563 16.2913 15.1416 16.2382L15.0254 16.1766C14.0644 15.6141 13.1011 15.054 12.1367 14.496L9.24219 12.829C9.07237 12.7323 8.94653 12.6198 8.86523 12.4784C8.78396 12.3369 8.74937 12.1708 8.75391 11.9725C8.7628 9.74963 8.7628 7.5265 8.75391 5.30359L8.75977 5.16687C8.7724 5.03582 8.80503 4.91961 8.8623 4.81628C8.93888 4.67822 9.0577 4.56712 9.22363 4.47449L12.1328 2.7948C13.1015 2.2335 14.0688 1.6707 15.0342 1.10828L15.1504 1.04773C15.2661 0.994399 15.3798 0.965632 15.4951 0.964722ZM21.0156 6.25964C19.4263 7.14485 17.8958 8.00507 16.3564 8.84753H16.3555C16.2542 8.90261 16.1944 8.95941 16.1582 9.02625C16.1216 9.09385 16.1064 9.17798 16.1064 9.2948V14.6552C16.1557 14.6359 16.1885 14.6262 16.2168 14.6093L16.2178 14.6083L18.5391 13.2684C19.3122 12.8209 20.0838 12.3717 20.8535 11.9208C20.8913 11.896 20.93 11.8478 20.9609 11.787C20.9919 11.7258 21.0117 11.658 21.0156 11.6034C21.0333 10.9264 21.0156 10.2596 21.0156 9.57996V6.25964ZM9.98438 6.27722V11.6161C9.98438 11.7178 10.0103 11.7819 10.0498 11.8309C10.0913 11.8822 10.1505 11.9208 10.2266 11.9657H10.2256C11.7205 12.8318 13.216 13.6983 14.7109 14.5643H14.7119L14.6924 14.5956L14.6895 14.6014L14.7119 14.5653C14.7436 14.5852 14.7805 14.6015 14.8242 14.619C14.8473 14.6283 14.8736 14.6385 14.9014 14.6493C14.9014 12.7733 14.9023 10.9402 14.8936 9.09851L14.877 9.04285C14.8657 9.02129 14.8486 8.99679 14.8262 8.97156C14.7833 8.92348 14.7285 8.88089 14.6816 8.8573L14.6787 8.85535C14.0603 8.49375 13.4391 8.13281 12.8174 7.77234L10.9502 6.69519C10.6395 6.51827 10.3288 6.3403 9.99512 6.1405C9.98889 6.20297 9.98438 6.23911 9.98438 6.27722ZM15.4697 2.31628C15.3966 2.32558 15.3233 2.35034 15.2725 2.38171L15.2715 2.38269L11.8896 4.32898C11.4783 4.56483 11.0577 4.80796 10.585 5.07507C11.3677 5.53052 12.1382 5.97577 12.9014 6.41785L15.2363 7.7782L15.3125 7.81921C15.3851 7.85292 15.449 7.86652 15.5107 7.86511C15.5524 7.86413 15.5949 7.85636 15.6396 7.84167L15.7832 7.77722C17.269 6.93808 18.7648 6.1169 20.25 5.28699L20.3906 5.20105C20.4216 5.18083 20.4529 5.15911 20.4863 5.1366C20.4673 5.11821 20.4555 5.10444 20.4424 5.09558V5.0946C19.647 4.63092 18.8513 4.17003 18.0537 3.71082L15.6484 2.33777C15.609 2.31467 15.5441 2.30684 15.4697 2.31628Z"
      fill="#474C5E"
      stroke="#474C5E"
      strokeWidth="0.1"
    />
  </svg>
)

const ICON_2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="28"
    viewBox="0 0 30 28"
    fill="none">
    <rect width="30" height="28" fill="white" />
    <path
      d="M7.5 20.5C5.56144 19.7246 5.03213 13.2495 5.00144 9.81691C4.99971 9.62259 4.89021 9.4451 4.7164 9.3582C4.38171 9.19085 3.98624 9.42654 3.97418 9.80054L3.52065 23.8598C3.50806 24.25 3.72372 24.6119 4.07292 24.7865L4.28885 24.8944C4.42771 24.9639 4.58082 25 4.73607 25H25.1172C25.6215 25 26.0469 24.6245 26.1095 24.124L26.3551 22.159C26.4312 21.55 25.9474 21.0168 25.3339 21.0324C19.5198 21.1802 9.36767 21.2471 7.5 20.5Z"
      fill="#D4DAE0"
    />
    <rect x="1" y="17" width="2" height="4" fill="#D4DAE0" />
    <rect x="27" y="17" width="2" height="4" fill="#D4DAE0" />
    <path
      d="M25 24.5V26H5V24.5H25ZM25.5 24V10C25.5 9.72386 25.2761 9.5 25 9.5H5C4.72386 9.5 4.5 9.72386 4.5 10V24C4.5 24.2761 4.72386 24.5 5 24.5V26L4.7959 25.9893C3.85435 25.8938 3.1062 25.1457 3.01074 24.2041L3 24V10C3 8.96435 3.78722 8.113 4.7959 8.01074L5 8H25L25.2041 8.01074C26.2128 8.113 27 8.96435 27 10V24L26.9893 24.2041C26.8938 25.1457 26.1457 25.8938 25.2041 25.9893L25 26V24.5C25.2761 24.5 25.5 24.2761 25.5 24Z"
      fill="#474C5E"
    />
    <path
      d="M28.25 20V14C28.25 13.8619 28.1381 13.75 28 13.75H26.333V12.25H28C28.9665 12.25 29.75 13.0335 29.75 14V20C29.75 20.9665 28.9665 21.75 28 21.75H26V20.25H28C28.1381 20.25 28.25 20.1381 28.25 20Z"
      fill="#474C5E"
    />
    <path
      d="M1.75 20V14C1.75 13.8619 1.86193 13.75 2 13.75H3.66699V12.25H2C1.0335 12.25 0.25 13.0335 0.25 14V20C0.25 20.9665 1.0335 21.75 2 21.75H4V20.25H2C1.86193 20.25 1.75 20.1381 1.75 20Z"
      fill="#474C5E"
    />
    <path d="M16 8L14.5 8L14.5 5L16 5L16 8Z" fill="#474C5E" />
    <path
      d="M16.5 3.5C16.5 2.94772 16.0523 2.5 15.5 2.5C14.9477 2.5 14.5 2.94772 14.5 3.5C14.5 4.05228 14.9477 4.5 15.5 4.5V6C14.1193 6 13 4.88071 13 3.5C13 2.11929 14.1193 1 15.5 1C16.8807 1 18 2.11929 18 3.5C18 4.88071 16.8807 6 15.5 6V4.5C16.0523 4.5 16.5 4.05228 16.5 3.5Z"
      fill="#474C5E"
    />
    <path
      d="M10.5 16.5C10.5 15.9477 10.0523 15.5 9.5 15.5C8.94772 15.5 8.5 15.9477 8.5 16.5C8.5 17.0523 8.94772 17.5 9.5 17.5V19C8.11929 19 7 17.8807 7 16.5C7 15.1193 8.11929 14 9.5 14C10.8807 14 12 15.1193 12 16.5C12 17.8807 10.8807 19 9.5 19V17.5C10.0523 17.5 10.5 17.0523 10.5 16.5Z"
      fill="#474C5E"
    />
    <path
      d="M20.5 16.5C20.5 15.9477 20.0523 15.5 19.5 15.5C18.9477 15.5 18.5 15.9477 18.5 16.5C18.5 17.0523 18.9477 17.5 19.5 17.5V19C18.1193 19 17 17.8807 17 16.5C17 15.1193 18.1193 14 19.5 14C20.8807 14 22 15.1193 22 16.5C22 17.8807 20.8807 19 19.5 19V17.5C20.0523 17.5 20.5 17.0523 20.5 16.5Z"
      fill="#474C5E"
    />
  </svg>
)

const ICON_3 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none">
    <path d="M2 22H25V27H2V22Z" fill="#D4DAE0" />
    <path d="M2 19H5V27H2V19Z" fill="#D4DAE0" />
    <path d="M21 4H27V6H21V4Z" fill="#D4DAE0" />
    <path
      d="M1.25 26V20C1.25 19.0335 2.0335 18.25 3 18.25H9V19.75H3C2.86193 19.75 2.75 19.8619 2.75 20V26C2.75 26.1381 2.86193 26.25 3 26.25H9V27.75H3C2.0335 27.75 1.25 26.9665 1.25 26Z"
      fill="#474C5E"
    />
    <path
      d="M8.25 16C8.25 15.0335 9.0335 14.25 10 14.25H17V15.75H10C9.86193 15.75 9.75 15.8619 9.75 16V26.25H17V27.75H8.25V16Z"
      fill="#474C5E"
    />
    <path
      d="M24.25 12C24.25 11.8619 24.1381 11.75 24 11.75H18C17.8619 11.75 17.75 11.8619 17.75 12V26.25H24C24.1381 26.25 24.25 26.1381 24.25 26V12ZM25.75 26C25.75 26.9665 24.9665 27.75 24 27.75H16.25V12C16.25 11.0335 17.0335 10.25 18 10.25H24C24.9665 10.25 25.75 11.0335 25.75 12V26Z"
      fill="#474C5E"
    />
    <path
      d="M20.25 1C20.25 0.585787 20.5858 0.25 21 0.25C21.4142 0.25 21.75 0.585787 21.75 1L21.75 11C21.75 11.4142 21.4142 11.75 21 11.75C20.5858 11.75 20.25 11.4142 20.25 11L20.25 1Z"
      fill="#474C5E"
    />
    <path
      d="M27.8926 1.25C28.6498 1.25002 29.0286 2.16571 28.4932 2.70117L27.1758 4.01758L28.3916 5.32031C28.8984 5.8637 28.5126 6.75 27.7695 6.75H21V5.25H26.2744L25.6514 4.58203C25.3391 4.24717 25.3481 3.72515 25.6719 3.40137L26.3232 2.75H21.1338V1.25H27.8926Z"
      fill="#474C5E"
    />
  </svg>
)

const AllPlatformSection: FCC<{ className?: string }> = ({ className }) => {
  const { t, i18n } = useTranslation()

  const SECTIONS = [
    {
      title: t('lp:all_platform_section:section_1_title'),
      iconType: ICON_1,
      contentImage: '/img/feature/lp/new/platform01.png',
      contentTitle: t('lp:all_platform_section:section_1_content_title'),
      contentDescription: t(
        'lp:all_platform_section:section_1_content_description'
      ),
      contentLink: TALENT_INTELLIGENCE_URL
    },
    {
      title: t('lp:all_platform_section:section_2_title'),
      iconType: ICON_2,
      contentImage: '/img/feature/lp/new/platform02.png',
      contentTitle: t('lp:all_platform_section:section_2_content_title'),
      contentDescription: t(
        'lp:all_platform_section:section_2_content_description'
      ),
      contentLink: TALENT_INTELLIGENCE_URL
    },
    {
      title: t('lp:all_platform_section:section_3_title'),
      iconType: ICON_3,
      contentImage: '/img/feature/lp/new/platform03.png',
      contentTitle: t('lp:all_platform_section:section_3_content_title'),
      contentDescription: t(
        'lp:all_platform_section:section_3_content_description'
      ),
      contentLink: TALENT_INTELLIGENCE_URL
    }
  ]

  return (
    <SectionContainer
      title="lp:all_platform_section:title"
      tagLabel="lp:all_platform_section:tag"
      tagColor="bg-blue-100 text-blue-800"
      className={cn(
        className,
        'pb-5 mt-[120px] mb-[100px] desktop:my-[120px]'
      )}>
      <div className="relative">
        <div className="h-5 border-gray-100 border-r absolute -top-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -left-5 border-dashed" />
        <div className="absolute -top-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -top-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -right-5 border-dashed" />
        <div className="absolute -top-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -left-5 border-dashed" />
        <div className="absolute -bottom-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -right-5 border-dashed" />
        <div className="absolute -bottom-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="flex flex-col tablet:flex-row align-middle w-full justify-center mt-6 border-gray-100 border border-r-0 border-b-0">
          {SECTIONS.map((item, index) => (
            <div
              key={index}
              className="flex-1 border-gray-100 border-r border-b">
              <div className="px-6 pt-5 flex items-center justify-between">
                <h3 className="font-medium text-base text-gray-900">
                  {/* {item.title} */}
                </h3>
                {item.iconType}
              </div>

              <Image
                src={item.contentImage}
                width={390}
                height={0}
                alt={`${item.contentImage}-image`}
                className="h-auto"
              />

              <div className="p-6 space-y-1">
                <p className="font-medium text-lg text-gray-900">
                  {item.contentTitle}
                </p>
                <p className="font-normal text-base text-gray-700">
                  {item.contentDescription}
                </p>
                <div className="animate-fadeInUp">
                  <Link href={item.contentLink} locale={i18n?.language}>
                    <TextButton
                      size="lg"
                      icon="trailing"
                      underline={false}
                      label={t('lp:learn_more')}
                      iconMenus="ArrowUpRight"
                    />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default AllPlatformSection
